import { useQuery } from "@tanstack/vue-query";

import { meQueryKeys } from "~/queries/identity/me";

function _useUser() {
  const { isLoggedIn } = useAuth();

  const { data: userDetail } = useQuery({
    ...meQueryKeys.detail(),
    enabled: isLoggedIn,
    staleTime: Infinity, // we can keep it until it's manually invalidated
  });

  const nuxtApp = useNuxtApp();

  // to de-dupe the identify call between different instances of this composable
  const isUserIdentifiedInAnalytics = useState("isUserIdentified", () => false);
  watch(userDetail, (newUserDetail) => {
    if (newUserDetail && !isUserIdentifiedInAnalytics.value) {
      identifyUserAnalytics(newUserDetail, nuxtApp);
      isUserIdentifiedInAnalytics.value = true;
    }
  });

  watch(
    isLoggedIn,
    (newIsLoggedIn) => {
      if (!newIsLoggedIn) {
        isUserIdentifiedInAnalytics.value = false;
      }
    },
    { immediate: true },
  );

  const user = computed(() => userDetail.value);

  const userId = computed(() => user.value?.id);

  return {
    userId,
    user,
  };
}

export const useUser = createSharedComposable(_useUser);
